import { createContext } from 'react'

import { createTableContextMenuStore } from '../store/createStore'

export const TableContextMenuStoreContext = createContext<
  ReturnType<typeof createTableContextMenuStore> | undefined
>(undefined)
